import "@elastic/eui/dist/eui_theme_light.css";
import LandingPage from "./components/LandingPage/LandingPage";
import { useRoutes } from "hookrouter";

const MyRoutes = () => {
  const routes = {
    "/": () => <LandingPage />,
  };

  const routeResults = useRoutes(routes);

  return routeResults || <h1>You got me! This doesn't work</h1>;
};

function App() {
  return (
    <div className="App">
      <MyRoutes />
    </div>
  );
}

export default App;
